import React, { Component } from 'react';

import { CanvasEditor } from 'components/canvasEditor';
import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import {
  CERTIFICATE_EDITOR_WIDTH,
  CERTIFICATE_EDITOR_HEIGHT
} from './constants';

@translate()
export default class ConfigCertificateEditor extends Component {
  static propTypes = {
    certificate: PropTypes.object,
    openCertificate: PropTypes.func
  };

  get certificateCanvasData() {
    const { certificate } = this.props;

    if (certificate && certificate.templateJson) {
      return certificate;
    }
  }

  isDefault(certificate) {
    return certificate && !certificate.id;
  }

  render() {
    const certificate = this.certificateCanvasData;
    const { openCertificate } = this.props;

    return (
      <CanvasEditor
        canvasData={certificate?.templateJson}
        openCertificate={openCertificate}
        width={CERTIFICATE_EDITOR_WIDTH}
        height={CERTIFICATE_EDITOR_HEIGHT}
        isDefault={this.isDefault(certificate)}
      />
    );
  }
}
